var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandFilterButtonMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.28,
    height: 28.28,
    viewBox: "0 0 28.28 28.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30039",
    "data-name": "Group 30039",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "highlight_off_black_18dp",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17483",
    "data-name": "Path 17483",
    d: "M0,0H28.28V28.28H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17484",
    "data-name": "Path 17484",
    d: "M14.14,2A12.14,12.14,0,1,0,26.28,14.14,12.129,12.129,0,0,0,14.14,2Zm0,21.852a9.712,9.712,0,1,1,9.712-9.712A9.725,9.725,0,0,1,14.14,23.852Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "keyboard_arrow_down_black_24dp",
    transform: "translate(2.531 1.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17622",
    "data-name": "Path 17622",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17623",
    "data-name": "Path 17623",
    d: "M7.41,8.59,12,13.17l4.59-4.58,1.453,2.024L12,16.6,6.043,10.614Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandFilterButtonMobile);
export default __webpack_public_path__ + "static/media/expand-filter-button-mobile.0e1bbd05408d7dd720e24b12e831566e.svg";
export { ForwardRef as ReactComponent };